
const newModel = () => {
    return {
        loaiDitichId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        loaiDitichId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        loaiDitichId: item.loaiDitichId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        loaiDitichId: item.loaiDitichId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        loaiDitichId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        loaiDitichId: item.loaiDitichId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        loaiDitichId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

export const loaiDiTichVHModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


